// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"ace78e1b","703":"aebb34cd","787":"cda612ba"}[chunkId] + ".chunk.js";
};